// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*:host {*/
/*    width: 100%;*/

/*}*/
.swiftref-table {
    font-family: var(--font-family), sans-serif;
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
}
.swiftref-table th,
.swiftref-table td {
    border-top: 1px solid var(--border-strong);
    border-bottom: 1px solid var(--border-strong);
    padding: var(--spacing-20);
    background: var(--background-white);
    text-align: left;
}
.swiftref-table td {
    border-top: 1px solid var(--border-light);
    border-bottom: 1px solid var(--border-light);
    word-break: break-all;
}
.swiftref-table td.ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.swiftref-table tbody > tr:last-child td {
    border-bottom: 1px solid var(--border-strong);
}
.swiftref-table tr {
    height: var(--spacing-50);
}

.swiftref-table > tbody > tr:nth-child(odd) td {
    background: var(--background-white);
}

:host([kind="zebra"]) tr:nth-child(2n) td,
.swiftref-table.zebra > tbody > tr:nth-child(2n) td,
.swiftref-table.zebra > tbody > tbody:nth-child(2n) td {
    background: var(--background-light);
}
.swiftref-table.sorting th:not(:empty) {
    cursor: pointer;
}



/*============================================================================*/
/*child rows*/
/*============================================================================*/
.swiftref-table td a.subtle {
    color: var(--text-default);
    font-family: var(--p2-regular-underlined-font-family), sans-serif;
    font-size: var(--p2-regular-underlined-font-family);
    letter-spacing: var(--p2-regular-underlined-font-family);
    line-height: var(--p2-regular-underlined-font-family);
    font-weight: var(--p2-regular-underlined-font-family);
}
.swiftref-table .child-row table {
    width: auto;
}
.swiftref-table .child-row td {
    background: var(--background-light);
    border: none;
}
.swiftref-table .child-row td:not(.title) {
    padding-top: unset;
    padding-bottom: unset;
}
.swiftref-table .child-row .title {
    font-family: var(--p2-medium-font-family), sans-serif;
    font-size: var(--p2-medium-font-size);
    letter-spacing: var(--p2-medium-letter-spacing);
    line-height: var(--p2-medium-line-height);
    font-weight: var(--p2-medium-font-weight);
}


@media (max-width: 940px) {
    :host,
    .swiftref-table {
        overflow-x: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/table/style/index.css"],"names":[],"mappings":";AACA,UAAU;AACV,mBAAmB;;AAEnB,IAAI;AACJ;IACI,2CAA2C;IAC3C,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,0CAA0C;IAC1C,6CAA6C;IAC7C,0BAA0B;IAC1B,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,yCAAyC;IACzC,4CAA4C;IAC5C,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,6CAA6C;AACjD;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;;IAGI,mCAAmC;AACvC;AACA;IACI,eAAe;AACnB;;;;AAIA,+EAA+E;AAC/E,aAAa;AACb,+EAA+E;AAC/E;IACI,0BAA0B;IAC1B,iEAAiE;IACjE,mDAAmD;IACnD,wDAAwD;IACxD,qDAAqD;IACrD,qDAAqD;AACzD;AACA;IACI,WAAW;AACf;AACA;IACI,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,qDAAqD;IACrD,qCAAqC;IACrC,+CAA+C;IAC/C,yCAAyC;IACzC,yCAAyC;AAC7C;;;AAGA;IACI;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":["\n/*:host {*/\n/*    width: 100%;*/\n\n/*}*/\n.swiftref-table {\n    font-family: var(--font-family), sans-serif;\n    border-collapse: collapse;\n    width: 100%;\n    table-layout: fixed;\n}\n.swiftref-table th,\n.swiftref-table td {\n    border-top: 1px solid var(--border-strong);\n    border-bottom: 1px solid var(--border-strong);\n    padding: var(--spacing-20);\n    background: var(--background-white);\n    text-align: left;\n}\n.swiftref-table td {\n    border-top: 1px solid var(--border-light);\n    border-bottom: 1px solid var(--border-light);\n    word-break: break-all;\n}\n.swiftref-table td.ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.swiftref-table tbody > tr:last-child td {\n    border-bottom: 1px solid var(--border-strong);\n}\n.swiftref-table tr {\n    height: var(--spacing-50);\n}\n\n.swiftref-table > tbody > tr:nth-child(odd) td {\n    background: var(--background-white);\n}\n\n:host([kind=\"zebra\"]) tr:nth-child(2n) td,\n.swiftref-table.zebra > tbody > tr:nth-child(2n) td,\n.swiftref-table.zebra > tbody > tbody:nth-child(2n) td {\n    background: var(--background-light);\n}\n.swiftref-table.sorting th:not(:empty) {\n    cursor: pointer;\n}\n\n\n\n/*============================================================================*/\n/*child rows*/\n/*============================================================================*/\n.swiftref-table td a.subtle {\n    color: var(--text-default);\n    font-family: var(--p2-regular-underlined-font-family), sans-serif;\n    font-size: var(--p2-regular-underlined-font-family);\n    letter-spacing: var(--p2-regular-underlined-font-family);\n    line-height: var(--p2-regular-underlined-font-family);\n    font-weight: var(--p2-regular-underlined-font-family);\n}\n.swiftref-table .child-row table {\n    width: auto;\n}\n.swiftref-table .child-row td {\n    background: var(--background-light);\n    border: none;\n}\n.swiftref-table .child-row td:not(.title) {\n    padding-top: unset;\n    padding-bottom: unset;\n}\n.swiftref-table .child-row .title {\n    font-family: var(--p2-medium-font-family), sans-serif;\n    font-size: var(--p2-medium-font-size);\n    letter-spacing: var(--p2-medium-letter-spacing);\n    line-height: var(--p2-medium-line-height);\n    font-weight: var(--p2-medium-font-weight);\n}\n\n\n@media (max-width: 940px) {\n    :host,\n    .swiftref-table {\n        overflow-x: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
